module.exports = __webpack_public_path__ + "static/media/L.bc47998b.svg";